export interface TestFlightDetectPlugin {
  checkTF(): Promise<{ "isFromTestFlight": boolean, "isInSimulator": boolean, "isFromAppStore": boolean }>;
}
